import React, { Fragment, useContext } from "react";
import ChatAppContext from "../../../Chat";
import { Link } from "react-router-dom";
import { capitalize } from "../../Common/CommonFunction";
import CustomizerContext from "../../../_helper/Customizer";
import avatar from "../../../../src/assets/images/avatar.png";
import { JOBSEEKER_PROFILE_IMAGE } from "../../../Constant";
const CurrentUser = () => {
  const { currentUser } = useContext(ChatAppContext) || {};
  console.log("currentUser", currentUser);
  return (
    <Fragment>
      {currentUser && (
        <div className="media">
          <img
            className="rounded-circle user-image"
            src={currentUser.jobseeker_photo || avatar}
            alt="profile image"
          />

          <div className="about">
            <Link to={`${process.env.PUBLIC_URL}/app/users/profile`}>
              <div className="name f-w-600">
                {capitalize(currentUser.jobseeker_full_name)}
              </div>
            </Link>
            <div className="status">{currentUser.status}</div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CurrentUser;
